export default function Footer() {
    return(
        <>
            <div className="container-fluid bg-light p-4">

                <div className="container">
                    <div className="row">

                        <div className="col-lg-4 mb-4">
                            <h5>FOLLOW US</h5>
                            <a href="https://www.facebook.com/homemotoph"><i className="bi-facebook fs-1 me-3"></i></a>
                            <a href="https://www.instagram.com"><i className="bi-instagram fs-1 me-3"></i></a>
                            <a href="http://linkedin.com"><i className="bi-linkedin fs-1 me-3"></i></a>
                            <a href="https://www.tiktok.com/@homemoto?fbclid=IwAR3joznhmx57bSg_D0YGCNz_gG6MyBzIg7SeNOFMdIFitReBXIfCc8iPjGs"><i className="bi-tiktok fs-1 me-3"></i></a>
                        </div>

                        <div className="col-lg-4 mb-4">
                            <h5>ABOUT US</h5>
                            <a href="/about" className="d-block">Our Story</a>
                            <a href="/privacy-policy" className="d-block">Privacy Policy</a>
                            <a href="/shipping-policy" className="d-block">Shipping Policy</a>
                            <a href="/return-policy" className="d-block">Return Policy</a>
                        </div>

                        <div className="col-lg-4 mb-4">
                            <h5>CONTACT US</h5>
                            <a className="d-block" href="/#contact">contact@homemoto.com.ph</a>
                        </div>
                    </div>

                    <br /><br />
                    <p className="text-center">&copy; Homemoto</p>
                </div>
            </div>
        </>
    );
}